import { useClaimPermissions } from '@/composables/session/useSession'

export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser().value
  if (!user)
    return navigateTo('/')

  const { canDistribute } = useClaimPermissions()
  if (!canDistribute.value)
    return navigateTo('/')
})
